import { render, staticRenderFns } from "./no-data-table.vue?vue&type=template&id=5e15b4a5&"
import script from "./no-data-table.vue?vue&type=script&lang=js&"
export * from "./no-data-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports